// src/components/Features.jsx
import React from "react";
import {
  Users,
  Coins,
  TrendingUp,
  ClipboardCheck,
  Network,
  Briefcase,
  Headset,
} from "lucide-react";

const services = [
  { id: 1, title: "Mentorship", icon: Users },
  { id: 2, title: "Funding Access", icon: Coins },
  { id: 3, title: "Incubation", icon: TrendingUp },
  { id: 4, title: "Startup Validation", icon: ClipboardCheck },
  { id: 5, title: "Network Connects", icon: Network },
  { id: 6, title: "Job Portal Access", icon: Briefcase },
  { id: 7, title: "Tech Support", icon: Headset },
];

const ServiceCard = ({ title, icon: Icon }) => {
  return (
    <div
      className="
        flex-none 
        w-40 
        bg-white 
        px-3 py-4
        rounded-lg 
        shadow-sm 
        transition-transform duration-300 hover:scale-105 
        flex flex-col items-center justify-center
      "
    >
      <div className="text-[#fd3e3d] mb-3">
        <Icon size={32} strokeWidth={1.5} />
      </div>
      <h3 className="text-sm font-medium text-gray-700 text-center">
        {title}
      </h3>
    </div>
  );
};

function Features() {
  // Calculate total width of all cards with gaps
  const cardWidth = 160; // w-40 = 160px
  const gapWidth = 16;   // gap-4 = 16px
  const totalWidth = services.length * (cardWidth + gapWidth);

  // Animation duration based on width (adjust divisor to speed up/slow down)
  const animationDuration = totalWidth / 50; // pixels per second

  return (
    <div className="w-full overflow-hidden pt-12 relative -mt-8">
      {/* Left shadow overlay */}
      <div
        className="
          absolute 
          top-0 left-0 
          h-full 
          w-12 
          pointer-events-none 
          bg-gradient-to-r 
          from-white to-transparent
        "
      />

      {/* Right shadow overlay */}
      <div
        className="
          absolute 
          top-0 right-0 
          h-full 
          w-12 
          pointer-events-none 
          bg-gradient-to-l 
          from-white to-transparent
        "
      />

      {/* Keyframes for the scrolling animation (embedded for simplicity) */}
      <style>
        {`
          @keyframes scroll {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-${totalWidth}px); }
          }
        `}
      </style>

      <div className="relative w-full">
        <div className="flex">
          <div
            className="flex gap-4 will-change-transform"
            style={{
              animation: `scroll ${animationDuration}s linear infinite`,
            }}
          >
            {/* Render multiple copies to ensure seamless looping */}
            {[...Array(3)].map((_, copyIndex) => (
              <React.Fragment key={`copy-${copyIndex}`}>
                {services.map((service) => (
                  <ServiceCard
                    key={`${copyIndex}-${service.id}`}
                    title={service.title}
                    icon={service.icon}
                  />
                ))}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Features;
